// extracted by mini-css-extract-plugin
module.exports = {"menuText":"menutext_menuText___Euwy","points":"menutext_points__1jWDO"};